/**
 * Corporate footer mounted on every HQ Command page (login + dashboard).
 * Discreet, single-line, fixed at bottom of viewport.
 */
export default function HqFooter() {
  return (
    <footer
      className="mt-auto border-t border-slate-900 bg-slate-950/80 backdrop-blur-sm py-3 px-6"
      data-testid="hq-footer"
    >
      <p className="text-[0.65rem] text-slate-600 text-center tracking-wide">
        PlateProfit © 2026 <span className="text-slate-500">Kritajna Ventures LLP</span>.
        All rights reserved.
      </p>
    </footer>
  );
}
